import { render, staticRenderFns } from "./ProductsSubCategory.vue?vue&type=template&id=78802d84"
import script from "./ProductsSubCategory.vue?vue&type=script&lang=js"
export * from "./ProductsSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports